import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpinnerService } from '../../services/sppiner/spinner.service';
import { Router } from '@angular/router';
import { ImageConverterPipe } from '../../pipes/image-converter.pipe';
import { interval, Subscription } from 'rxjs';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, ImageConverterPipe, TranslateModule],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {

  currentSlide = 0;
  selectedService = 1;

  serviceList = [
    { id: 1, key: 'architecture' },
    { id: 2, key: 'cloud_native' },
    { id: 3, key: 'agile_cells' },
    { id: 4, key: 'support' },
    { id: 5, key: 'devops' }
  ];

  slides = [
    {
      image: 'assets/webp/img03.webp',
      alt: 'Slide 1',
      titleKey: 'home_carousel.slide1.title',
      descriptionKey: 'home_carousel.slide1.description',
      subdescriptionKey: 'home_carousel.slide1.subdescription',
      link: '#',
      srcset: 'assets/webp/img03-small.webp 640w, assets/webp/img03-medium.webp 1024w, assets/webp/img03-large.webp 1440w, assets/webp/img03-xl.webp 1920w'
    },
    {
      image: 'assets/webp/img-08.webp',
      alt: 'Slide 2',
      titleKey: 'home_carousel.slide2.title',
      descriptionKey: 'home_carousel.slide2.description',
      subdescriptionKey: 'home_carousel.slide2.subdescription',
      link: '#',
      srcset: 'assets/webp/img-08-small.webp 640w, assets/webp/img-08-medium.webp 1024w, assets/webp/img-08-large.webp 1440w, assets/webp/img-08-xl.webp 1920w'
    }
  ];

  autoSlideSubscription: Subscription = new Subscription();
  autoSlideDuration = 30000;
  slideInterval = 10000;

  constructor(
    private spinnerService: SpinnerService,
    private router: Router,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.startAutoSlide();
  }

  ngOnDestroy(): void {
    this.stopAutoSlide();
  }


  trackByServiceId(index: number, service: { id: number; key: string }): number {
    return service.id;
  }

  previousSlide(): void {
    this.currentSlide = (this.currentSlide === 0)
      ? this.slides.length - 1
      : this.currentSlide - 1;
  }

  nextSlide(): void {
    this.currentSlide = (this.currentSlide === this.slides.length - 1)
      ? 0
      : this.currentSlide + 1;
  }

  goToSlide(index: number): void {
    this.currentSlide = index;
  }

  goToAbout(): void {
    this.spinnerService.show();
    setTimeout(() => {
      this.router.navigate(['/about']);
      this.spinnerService.hide();
    }, 500);
  }

  goToContact(): void {
    this.spinnerService.show();
    setTimeout(() => {
      this.router.navigate(['/contact']);
      this.spinnerService.hide();
    }, 500);
  }

  selectService(service: number, event: MouseEvent): void {
    event.preventDefault();
    this.selectedService = service;
  }

  getServiceDescription(): string {
    return this.translate.instant(`home_services_mobile.descriptions.${this.selectedService}`);
  }

  getServiceLink(): string {
    return `/arqit-services/${this.selectedService}`;
  }

  goToService(): void {
    this.spinnerService.show();
    setTimeout(() => {
      this.router.navigate([this.getServiceLink()]);
      this.spinnerService.hide();
    }, 500);
  }

  private startAutoSlide(): void {
    this.autoSlideSubscription = interval(this.slideInterval).subscribe(() => {
      this.nextSlide();
    });

    setTimeout(() => {
      this.stopAutoSlide();
    }, this.autoSlideDuration);
  }

  private stopAutoSlide(): void {
    if (this.autoSlideSubscription) {
      this.autoSlideSubscription.unsubscribe();
    }
  }
}
